import React, {useState, useEffect} from 'react'
import Header from '../../components/Header/Header'
import bannerImg from "../../assets/images/presentation.jpg"
// import bannerImg from "../../assets/images/portail_bcc.jpg"
import "./Presentation.css"
import { getPresentation } from '../../services/http'
import ReactMarkdown from 'react-markdown'
import Loader from '../../components/Loader/Loader'

const Presentation = () => {

const [about, setAbout] = useState("");

const loadPresentation = async () => {
  const req = await getPresentation()
    if (req.response && req.reponse?.status !== 200) {
        console.log(req.response)
     } else {
         console.log("Okay", req.data)
           setAbout(req?.data?.description)     
     }

   
   }

  useEffect(() => {
    loadPresentation();
  }, []);



  return (
    <div id="presentaion">
      <Header bannerImg={bannerImg} title={"Présentation"}/>
<div className='w-80 mx-auto'>
  <p className='mt-3'>
{about != "" ? <ReactMarkdown>{about}</ReactMarkdown> : <div style={{ marginTop: "5%" }}>
                                    <Loader />
                                </div>}
  </p>
      {/* <p className='presentation-title mt-3 '>Genèse du projet</p>
      <p className='presentation-content'>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>

      <p className='presentation-content'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
      <p className='presentation-title'>Mentions Légales</p>
      <p className='presentation-content'>This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
Texte de loi du 4 Janvier 2016
Convention des banques du Congo
Loi sur le consommateurs 2012</p>
      <p className='presentation-content'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. </p> */}

      </div>
    </div>
  )
}

export default Presentation